var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.7,342.7H0v183.3h183.3v-72.7h-110.6v-110.6ZM0,197.3h72.7v-110.6h109.6V14H0v183.3ZM439.3,453.3h-110.6v72.7h183.3v-183.3h-72.7v110.6ZM328.7,14v72.7h109.6v109.6h73.7V14h-183.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.7,342.7H0v183.3h183.3v-72.7h-110.6v-110.6ZM0,197.3h72.7v-110.6h109.6V14H0v183.3ZM439.3,453.3h-110.6v72.7h183.3v-183.3h-72.7v110.6ZM328.7,14v72.7h109.6v109.6h73.7V14h-183.3Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.7,328.7H0v183.3h183.3v-72.7h-110.6v-110.6ZM0,183.3h72.7v-110.6h109.6V0H0v183.3ZM439.3,439.3h-110.6v72.7h183.3v-183.3h-72.7v110.6ZM328.7,0v72.7h109.6v109.6h73.7V0h-183.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.7,328.7H0v183.3h183.3v-72.7h-110.6v-110.6ZM0,183.3h72.7v-110.6h109.6V0H0v183.3ZM439.3,439.3h-110.6v72.7h183.3v-183.3h-72.7v110.6ZM328.7,0v72.7h109.6v109.6h73.7V0h-183.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.7,328.7H0v183.3h183.3v-72.7h-110.6v-110.6ZM0,183.3h72.7v-110.6h109.6V0H0v183.3ZM439.3,439.3h-110.6v72.7h183.3v-183.3h-72.7v110.6ZM328.7,0v72.7h109.6v109.6h73.7V0h-183.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.7,328.7H0v183.3h183.3v-72.7h-110.6v-110.6ZM0,183.3h72.7v-110.6h109.6V0H0v183.3ZM439.3,439.3h-110.6v72.7h183.3v-183.3h-72.7v110.6ZM328.7,0v72.7h109.6v109.6h73.7V0h-183.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.7,328.7H0v183.3h183.3v-72.7h-110.6v-110.6ZM0,183.3h72.7v-110.6h109.6V0H0v183.3ZM439.3,439.3h-110.6v72.7h183.3v-183.3h-72.7v110.6ZM328.7,0v72.7h109.6v109.6h73.7V0h-183.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenIcon);
export default __webpack_public_path__ + "static/media/fullscreen-icon.d05bb3fe7dd018216dd71f05e50b2279.svg";
export { ForwardRef as ReactComponent };